<template>
    <div>
        <!-- Modal Nota Fiscal -->
        <div
            class="modal fade"
            id="notaFiscalGeracaoModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modelTitleId"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-lg modal-dialog-scrollabl"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Nota Fiscal</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" >
                        <template v-if="possuiNF">

                            <div class="list-group mb-3">
                                <div
                                    class="list-group-item d-flex"
                                    v-for="(nfl, idx) in listaNf"
                                    :key="idx"
                                >
                                    <span class="mr-3">{{
                                        $util.getFormatDate(
                                            nfl.nota_fiscal_servico.dt_emissao
                                        )
                                    }}</span>
                                    <span class="mr-3"
                                        >{{ nfl.nota_fiscal_servico.numero_completo }}
                                    </span>
                                    <span class="mr-3 text-warning" v-if="nfl.nota_fiscal_servico.id_empresa">
                                        Tomador: {{ nfl.nota_fiscal_servico.tomador }}
                                    </span>
                                    <span
                                        class="mr-3"
                                        :class="
                                            getStatusClass(
                                                nfl.nota_fiscal_servico.ch_status
                                            )
                                        "
                                        >{{
                                            nfl.nota_fiscal_servico.descricao_status
                                        }}</span
                                    >
                                    <span
                                        class="mr-3"
                                        >{{
                                            $util.formatMoeda(nfl.nota_fiscal_servico.dc_valor_liquido_nfse)
                                        }}</span
                                    >
                                    <span
                                        class="mr-3"
                                        v-if="podeEmietirNotaFiscalEletronica"
                                    >
                                        <nota-fiscal-status
                                            :exibirEditar="false"
                                            :notaFiscal="nfl.nota_fiscal_servico"
                                            @refresh="refresh()"
                                        />
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template v-if="podeEmitirOutraNota">
                            <div class="row" v-if="avulso">
                                <div class="col col-12 col-md-12">
                                    <az-input   
                                        type="select"
                                        icon="fa fa-building fa-fw"
                                        placeholder="Selecione a Unidade..."
                                        :optionsList="$store.state.unidade.unidade_operacaos"
                                        optionsData="id_unidade_operacao"
                                        v-model="filtros.id_unidade_operacao" 
                                        @input="carregarCNAEs()"
                                        />
                                </div>
                            </div>
                            <div class="row" v-if="avulso && cnaes && cnaes.length > 0 && filtros.id_unidade_operacao">
                                <div class="col col-12 col-md-12">
                                    <az-input
                                        icon="far fa-building fa-fw"
                                        type="select" 
                                        optionsData="id_cnae"
                                        optionsDisplay="search"
                                        :optionsList="cnaes"
                                        placeholder="Selecione o CNAE..."
                                        :edicao="avulso"
                                        v-model="filtros.id_cnae">
                                    </az-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12 col-md-12">
                                    <az-input
                                        icon="far fa-credit-card fa-fw"
                                        type="select" 
                                        optionsMode="aql"
                                        optionsData="id_operadora"
                                        optionsDisplay="st_operadora"
                                        service="operadoras.index"
                                        optionsName="operadoras-para-fatura"
                                        placeholder="Selecione a Operadora..."
                                        :edicao="avulso"
                                        required
                                        v-model="filtros.id_operadora"
                                        @input="carregarEmpresas()">
                                    </az-input>
                                </div>
                            </div>
                            <div class="row" v-if="empresas && empresas.length > 0 && filtros.id_operadora">
                                <div class="col col-12 col-md-12">
                                    <az-input
                                        icon="far fa-credit-card fa-fw"
                                        type="select" 
                                        optionsData="id_empresa_operadora"
                                        optionsDisplay="search"
                                        :optionsList="empresas"
                                        placeholder="Selecione a empresa..."
                                        :edicao="empresas && empresas.length > 0"
                                        :required="empresas && empresas.length > 0"
                                        :validate="validate"
                                        v-model="filtros.id_empresa_operadora">
                                    </az-input>
                                </div>
                            </div>
                            <div class="row" v-if="contratos && contratos.length > 0 && filtros.id_operadora">
                                <div class="col col-12 col-md-12">
                                    <az-input
                                        icon="far fa-credit-card fa-fw"
                                        type="select" 
                                        optionsData="id_contrato_operadora"
                                        optionsDisplay="search"
                                        :optionsList="contratos"
                                        placeholder="Selecione o contrato (para cálculo de impostos)..."
                                        :edicao="contratos && contratos.length > 0"
                                        :validate="validate"
                                        v-model="filtros.id_contrato_operadora">
                                    </az-input>
                                </div>
                            </div>
                            <div class="row" v-if="!verifica_recebimentos">
                                <div class="col col-12 col-md-12">
                                    <az-input
                                        v-if="filtros.exibir"
                                        icon="fas fa-money-bill-alt fa-fw"
                                        type="money" 
                                        :edicao="avulso"
                                        required
                                        v-model="filtros.valor">
                                    </az-input>
                                </div>
                            </div>
                            
                            <template v-if="avulso">
                                <div v-if="filtros.id_operadora" class="my-2">
                                    <button type="button" class="btn btn-sm btn-outline-primary mb-2" @click="verifica_recebimentos = !verifica_recebimentos; recebimentos = null;">Verificar Recebimentos</button>

                                    <div v-if="verifica_recebimentos">
                                        <div class="form-row">
                                            <div class="col col-12">
                                                <az-periodo v-model="periodo" :sync="true" @sync="verificar_recebimentos()" />
                                            </div>
                                        </div>

                                        <table class="table table-sm mt-2" v-if="recebimentos && recebimentos.lista && recebimentos.lista.length">
                                            <thead>
                                                <tr>
                                                    <th colspan="2">Fatura</th>
                                                    <th>Recebimento</th>
                                                    <th>NF</th>
                                                    <th class="text-right">Valor</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(receb, irx) in recebimentos.lista" :key="irx">
                                                    <td width="1%"><input type="checkbox" v-model="receb.calcular" :disabled="receb.lista_notas ? true : false"></td>
                                                    <td>#{{ receb.id_fatura }}</td>
                                                    <td>{{ $util.getFormatDate(receb.dt_retorno) }}</td>
                                                    <td>{{ receb.lista_notas }}</td>
                                                    <td class="text-right">{{ $util.formatMoeda(receb.valor) }}</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th colspan="4">Selecionado</th>
                                                    <th class="text-right">{{ $util.formatMoeda(receb_total) }}</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input 
                                            label="Descrição"
                                            type="textarea"
                                            rows="3"
                                            placeholder="Padrão..."
                                            v-model="filtros.descricao" />
                                    </div>
                                </div>

                                <div class="row my-2">
                                    <div class="col col-12">
                                        <az-input type="checkbox-group" label="Definir Valores Manualmente" v-model="filtros.definir_impostos" />
                                    </div>
                                </div>

                                <template v-if="filtros.definir_impostos">
                                    <!-- Impostos -->
                                    <div class="form-row">
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="Base de Cálculo"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_base_calculo">
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="Valor Deduções"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_valor_deducoes">
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="Outras Retenções"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_outras_retencoes">
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="PIS"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_valor_pis">
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="COFINS"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_valor_cofins">
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="CSLL"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_valor_csll">
                                            </az-input>
                                        </div>

                                    </div>

                                    <!-- VALOR TOTAL e chave de acesso -->
                                    <div class="form-row">
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="IRRF"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_valor_irrf">
                                            </az-input>
                                        </div>
                                        
                                        <!-- <div class="col col-12 col-md-2">
                                            <az-input
                                                label="Valor Liquido NF"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_valor_liquido_nfse">
                                            </az-input>
                                        </div> -->

                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                type="checkbox"
                                                label="Iss Retido"
                                                sizing="sm"
                                                v-model="filtros.reter_iss">
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="Aliquota ISS"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_aliquota">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">
                                                            <i class="fas fa-percent"></i>
                                                        </span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="ISS"
                                                sizing="sm"
                                                type="money"
                                                v-model="filtros.dc_valor_iss">
                                            </az-input>
                                        </div>

                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                label="Valor Liquido NF"
                                                sizing="sm"
                                                :type="calculando_valor ? 'number' : 'money'"
                                                :readonly="true"
                                                v-model="filtros.dc_valor_liquido_nfse">
                                            </az-input>
                                        </div>
                                    </div>
                                </template>
                            </template>

                            <div class="row" v-if="podeEmietirNotaFiscalEletronica">
                                <div class="col col-12 col-md-12 mt-4">
                                    <az-input type="checkbox-group" label="Emitir Nota Fiscal no site da Prefeitura" v-model="filtros.fl_emitir" />
                                </div>
                            </div>
                        </template>
                    </div> 
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <az-submit v-if="podeEmitirOutraNota"  @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import _ from 'lodash';
import AzSubmit from "../../util/AzSubmit.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import NotaFiscalStatus from "./NotaFiscalStatus.vue";
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data() {
        return {
            filtros: {
                id_unidade_operacao: '', 
                id_cnae: '',
                id_empresa_operadora: '',
                id_operadora: '',
                valor: 0,
                exibir: false,
                fl_emitir: false,
                definir_impostos: false, 
                dc_base_calculo: 0, 
                dc_valor_deducoes: 0,
                dc_outras_retencoes: 0,
                dc_valor_pis: 0,
                dc_valor_cofins: 0,
                dc_valor_csll: 0,
                dc_valor_irrf: 0,
                dc_valor_liquido_nfse: 0,
                reter_iss: false, 
                dc_aliquota: 0,
                dc_valor_iss: 0,
            },
            validate: false,
            avulso: false,
            fatura: null,
            verifica_recebimentos: false, 
            recebimentos: null, 
            periodo: { 
                periodo: 'm',
                inicio: '',
                fim: '', 
            },
            cnaes: [],
            empresas: [],
            contratos: [],
            calculando_valor: false,
        };
    },
    components: {
        AzSubmit,
        AzInput,
        NotaFiscalStatus,
        AzPeriodo,
    },

    watch: {
        'filtros.definir_impostos': function (newValue) {
            if (newValue) {
                this.filtros.dc_base_calculo = this.filtros.valor;
            }
        },
        'filtros.dc_base_calculo': 'updateValorLiquido',
        'filtros.dc_valor_deducoes': 'updateValorLiquido',
        'filtros.dc_outras_retencoes': 'updateValorLiquido',
        'filtros.dc_valor_pis': 'updateValorLiquido',
        'filtros.dc_valor_cofins': 'updateValorLiquido',
        'filtros.dc_valor_csll': 'updateValorLiquido',
        'filtros.dc_valor_irrf': 'updateValorLiquido',
        'filtros.reter_iss': 'updateValorLiquido',
        'filtros.dc_valor_iss': 'updateValorLiquido',
        'filtros.dc_valor_liquido_nfse': function () {}
    },

    computed: {
        receb_total: function () { 
            if ( !this.recebimentos || !this.recebimentos.lista ) 
                return 0;

            console.log('list', this.recebimentos.lista.filter(item => item.calcular));

            return _.sumBy(this.recebimentos.lista.filter(item => item.calcular), item => item.valor ? parseFloat(item.valor) : 0);
        },

        podeEmietirNotaFiscalEletronica: function() {
            return this.fatura 
                && this.fatura.guia_fatura 
                && this.fatura.guia_fatura.guia
                && this.fatura.guia_fatura.guia.atendimento
                && this.fatura.guia_fatura.guia.atendimento.unidade_operacao
                && this.fatura.guia_fatura.guia.atendimento.unidade_operacao.fl_nota_fiscal_eletronica;
        },

        podeEmietirNotaFiscal: function() {
            return this.fatura 
                && this.fatura.guia_fatura 
                && this.fatura.guia_fatura.guia
                && this.fatura.guia_fatura.guia.atendimento
                && this.fatura.guia_fatura.guia.atendimento.unidade_operacao
                && this.fatura.guia_fatura.guia.atendimento.unidade_operacao.fl_nota_fiscal;
        },
        possuiNF: function() {
            return this.fatura 
                && this.fatura.nota_fiscal_link 
                && this.fatura.nota_fiscal_link.nota_fiscal_servico;
        },
        podeEmitirOutraNota: function() {
            return (!this.fatura  
                    || (this.fatura
                        && (!this.fatura.nota_fiscal_link 
                            || (this.fatura.nota_fiscal_link 
                                && (this.fatura.nota_fiscal_link.nota_fiscal_servico.ch_status == '3' || 
                                    this.fatura.nota_fiscal_link.nota_fiscal_servico.ch_status == '5')
                                )
                        )
                    )
            );  // Emitida
        },

        listaNf: function() {
            if(!this.possuiNF) return [];

            return this.fatura.nota_fiscal_links;
        }
    },

    methods: {
        refresh() {
            this.$emit('refresh');
        },

        updateValorLiquido() {
            if (this.calculando_valor) return;

            this.calculando_valor = true;

            this.$nextTick(() => {
                let valor = this.filtros.dc_base_calculo -
                    this.filtros.dc_valor_deducoes -
                    this.filtros.dc_outras_retencoes -
                    this.filtros.dc_valor_pis -
                    this.filtros.dc_valor_cofins -
                    this.filtros.dc_valor_csll -
                    this.filtros.dc_valor_irrf -
                    (this.filtros.reter_iss ? this.filtros.dc_valor_iss : 0);

                if(valor < 0) {
                    valor = 0;
                }

                if (this.filtros.dc_valor_liquido_nfse !== valor) {
                    this.filtros.dc_valor_liquido_nfse = valor;
                }

                this.calculando_valor = false;
            });
        },

        carregarCNAEs() {
            this.cnaes = [];

            console.log(this.$store.state.unidade);


            this.$util.load(this, {
                service: 'cnaes',
                func: 'index',
                parms: {
                    id_unidade_operacao: this.filtros.id_unidade_operacao,
                    nfse_cnae: true,
                    ativos: true
                },
                loadTo: res => {
                    this.cnaes = res;
                }
            });
        },

        carregarEmpresas() {
            this.recebimentos = null;
            this.empresas = [];
            this.filtros.id_empresa_operadora = '';

            this.$util.load(this, {
                service: 'empresa_operadoras',
                func: 'index',
                parms: {
                    id_operadora: this.filtros.id_operadora,
                },
                loadTo: res => {
                    this.empresas = res;
                }
            });
            this.carregarContratos();
      },

      carregarContratos() {
            this.recebimentos = null;
            this.contratos = [];
            this.filtros.id_contrato_operadora = '';

            this.$util.load(this, {
                service: 'contrato_operadoras',
                func: 'index',
                parms: {
                    id_operadora: this.filtros.id_operadora,
                },
                loadTo: res => {
                    this.contratos = res;
                }
            });
        },

        verificar_recebimentos () { 
            this.$util.load(this, { 
                service: 'faturas',
                func: 'verificar_recebimentos',
                parms: { 
                    ...this.periodo,
                    id_operadora: this.filtros.id_operadora, 
                },
                loadTo: res => { 
                    this.recebimentos = res;
                }
            });
        },

        getStatusClass: function(status) {
            switch (status) {
                case "1":
                    return "text-info";
                case "2":
                    return "text-primary";
                case "3":
                    return "text-warning";
                case "4":
                    return "text-success";
                case "5":
                    return "text-danger";

                default:
                    return "text-info";
            }
        },
        emitirNotaFiscalFatura(fatura) {
            this.fatura = _.cloneDeep(fatura);

            this.filtros.id_operadora = this.fatura.id_operadora;
            this.carregarEmpresas();
            this.filtros.valor = this.fatura.valor_total.total;
            this.filtros.definir_impostos = false;

            this.filtros.exibir = true;

            this.avulso = false;

            $("#notaFiscalGeracaoModal").modal("show");
        },      
       
        emitirNotaFiscalAavulso() {
            this.avulso = true;
            this.filtros.id_unidade_operacao = "";
            this.filtros.exibir = true;
            this.filtros.id_operadora = "";
            this.filtros.valor = 0;
            this.filtros.definir_impostos = false;
            this.filtros.dc_base_calculo = 0; 
            this.filtros.dc_valor_deducoes = 0;
            this.filtros.dc_outras_retencoes = 0;
            this.filtros.dc_valor_pis = 0;
            this.filtros.dc_valor_cofins = 0;
            this.filtros.dc_valor_csll = 0;
            this.filtros.dc_valor_irrf = 0;
            this.filtros.dc_valor_liquido_nfse = 0;
            this.filtros.reter_iss = false; 
            this.filtros.dc_aliquota = 0;
            this.filtros.dc_valor_iss = 0;
            this.filtros.id_cnae = "";
            this.filtros.id_empresa_operadora = "";
            this.filtros.id_contrato_operadora = "";
            this.cnaes = [];
            this.empresas = [];

            $("#notaFiscalGeracaoModal").modal("show");
        },     
        atualizar() {
            if ( !confirm('Deseja realmente Gerar a Nota Fiscal?') )
                return;

            let dados = {
                emitir: this.filtros.fl_emitir,
            };
            let func = '';
            
            if(this.avulso) {
                func = 'gerar_nf_avulsa';
                dados.id_unidade_operacao = this.filtros.id_unidade_operacao;
                dados.id_operadora = this.filtros.id_operadora;
                dados.valor = this.filtros.valor;
                dados.descricao = this.filtros.descricao;
                dados.definir_impostos = this.filtros.definir_impostos;

                if ( this.verifica_recebimentos && this.recebimentos && this.recebimentos.lista.find(item => item.id_operadora = this.filtros.id_operadora) ) { 
                    dados.recebimentos = this.recebimentos.lista.filter(item => item.calcular);
                    dados.valor = this.receb_total;
                }

                if(this.cnaes && this.cnaes.length > 0) {
                    dados.id_cnae = this.filtros.id_cnae;
                }

                if(this.empresas && this.empresas.length > 0) {
                    dados.id_empresa_operadora = this.filtros.id_empresa_operadora;
                }

                if(this.contratos && this.contratos.length > 0) {
                    dados.id_contrato_operadora = this.filtros.id_contrato_operadora;
                }

                if ( dados.definir_impostos ) { 
                    dados.fl_calculo_manual = true;
                    dados.dc_base_calculo = this.filtros.dc_base_calculo; 
                    dados.dc_valor_deducoes = this.filtros.dc_valor_deducoes;
                    dados.dc_outras_retencoes = this.filtros.dc_outras_retencoes;
                    dados.dc_valor_pis = this.filtros.dc_valor_pis;
                    dados.dc_valor_cofins = this.filtros.dc_valor_cofins;
                    dados.dc_valor_csll = this.filtros.dc_valor_csll;
                    dados.dc_valor_irrf = this.filtros.dc_valor_irrf;
                    dados.dc_valor_liquido_nfse = this.filtros.dc_valor_liquido_nfse;
                    dados.reter_iss = this.filtros.reter_iss;
                    dados.dc_aliquota = this.filtros.dc_aliquota;
                    dados.dc_valor_iss = this.filtros.dc_valor_iss;
                }
            } else {
                func = 'gerar_nf_fatura';
                dados.id_fatura = this.fatura.id_fatura;

                if(this.empresas && this.empresas.length > 0) {
                    dados.id_empresa_operadora = this.filtros.id_empresa_operadora;
                }

                if(this.contratos && this.contratos.length > 0) {
                    dados.id_contrato_operadora = this.filtros.id_contrato_operadora;
                }
            }

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: func,
                toast: true,
                modal: "notaFiscalGeracaoModal",
                dados: {
                    ...dados
                },
                callback: () => {
                    this.validate = false;
                    this.$emit('refresh_gerar');
                }
            });
        }
    }
};
</script>

<style></style>
